import { connectRouter } from 'connected-react-router'
import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'

import bookReducer from './book.reducers'
import drawerReducer from './drawer.reducers'
import googleReducer from './google.reducers'
import headerReducer from './header.reducers'
import studentReducer from './student.reducers'
import userReducer from './user.reducers'

const rootReducer = (history) =>
  combineReducers({
    books: bookReducer,
    drawer: drawerReducer,
    form: formReducer,
    google: googleReducer,
    header: headerReducer,
    router: connectRouter(history),
    students: studentReducer,
    user: userReducer,
  })

export default rootReducer
